import React from 'react';
import { PERMISSIONS_KEY, ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import EndUsersTabs from '../components/EndUsersTabs';
import AccessControl from '../../../../../AccessControl';
import UserReturnTable from '../../../../orders/modules/combined-orders/components/ReturnTable';

const Returns = ({ match: { params: { id, userNumber } = {} } = {} }) => (
  <>
    <Portal portalId="header-title-content">
      <GoBackButton
        customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
      />
      <div className="portal-header">View End User</div>
    </Portal>
    <EndUsersTabs endUserId={id} endUserNumber={userNumber} isView>
      <div className="tab-table">
        <AccessControl permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS}>
          <UserReturnTable userId={id} isSystemUsersTab />
        </AccessControl>{' '}
      </div>
    </EndUsersTabs>
  </>
);

export default Returns;
